exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".extra-payment-errors {\n  color: #cf4931;\n  font-family: 'Calibre-Regular', Arial, sans-serif;\n}\n.extraPaymentsRoot .note {\n  font-size: 80%;\n  vertical-align: -8px;\n}\n.extraPaymentsDiv .number-input__error {\n  position: absolute;\n}\n.extraPaymentsDiv label.form-label {\n  text-align: left;\n}\n", ""]);

// exports
